let gwp_used_coupon;
let $gwp_product;
let $gwp_coupon_block;
let $gwp_block;


/* We have different event, depends on what cart we use - "Cart Drawer" or general Cart Page */
let gwp_init_event = actuall_template_name == 'cart' ? "theme:cartpage:ready" : "theme:cart:loaded";


let apply_coupon = false; 


let cart_previous_data = false;
let cart_new_data = false;


document.addEventListener(gwp_init_event, (e)=>{
  console.log("GWP INITIAL LOAD");

  cart_previous_data = JSON.stringify(cart);


  gwp_used_coupon = getCookie("gwp_discount");


  let $gwp_block_wrapper = document.querySelector('.gwp-wrapper');

  $gwp_block = document.querySelector('.gwp-wrapper .gwp-block');


  let $gwp_open_button = document.querySelectorAll('.gwp-wrapper .gwp-open-button');

  $gwp_product = $gwp_block.querySelectorAll('.product-element');


  //GWP Tiers Progress Bar elements
  let $tier_progress_bar = document.querySelector('.gwp-progress-bar-wrapper');
  let $tier_progress_bar_line = $tier_progress_bar.querySelector('.helper');
  let $tier_prgress_bar_value = $tier_progress_bar.querySelector('.goal .value');
  let $tier_progress_bar_title = $tier_progress_bar.querySelector('.title');


  //Check if we need to auto-add an item from GWP tier with single item (if we meet the tier threshold)
  check_autoadd_gwp_tier();


  //Hide/Show buttons for showing GWP popup
  function check_max_gwp_items(tier){
    //Work with buttons
    if(tier.gwp_type == 'original'){
      //Original GWP system, we need to check the buttons
      
      //Find "Open" button And Decided what to do with it
      $gwp_open_button.forEach(item=>{
        if(item.classList.contains('gwp-open-button-tier-'+tier.id)){
          if(tier.already_in_cart_count  < tier.max_gwp_items){
            item.classList.add('show-flex');
          }
          else{
            item.classList.remove('show-flex');
          }

        }
      })
    }

    
    if(tier.already_in_cart_count >= tier.max_gwp_items){

      //Close popup, if this popup is open
      if($gwp_block.dataset.tier_id == tier.id){
        $gwp_block.classList.remove('active');
      }


      //Change applied coupon info text to "Completed"
      if(tier.gwp_type == 'coupon'){
        gwp_coupon_validation_status({'gwp':'complete'});
      }
    }


    //Change available GWP products
    $gwp_block.querySelector('.available-gwp-count').innerHTML = tier.max_gwp_items - tier.already_in_cart_count;
  }







  //Add GWP product to the cart
  $gwp_block.querySelectorAll('.products-list .add').forEach(item=>{
    item.addEventListener('click', function(){

      //Prevent Double Click
      if(item.classList.contains('process')){
        return false;
      }
      item.classList.add('process');


      //Get needed params
      let $block = item.closest('.product-element');
      //Current Tier??
      let tier_id = item.closest('.gwp-block').dataset.tier_id;    


      //Check what we need to do - select or unselect
      if($block.classList.contains('gwp-selected')){
        //Delete item
        gwp_settings[tier_id].already_in_cart_count--;

        let updates = {};
        updates[item.dataset.key] = 0;
        
        gwp_ajax_work('update',{updates:updates}, function(){
          item.classList.remove('process');
        });
      
      }
      else{
        //Add Item
        gwp_settings[tier_id].already_in_cart_count++;


        //Remove Item From "Don't Auto Add" list
        gwp_previously_removed_remove($block.dataset.id);


        gwp_ajax_work('add',{
          id:$block.dataset.id,
          quantity:1,
          properties:{
            _gwp_tier_id:tier_id,
            _gwp_reporting_title:gwp_settings[tier_id].reporting_title
          }          
        },function(data){
          item.dataset.key = data.key;
          item.classList.remove('process');
        });

        /*
          After addin a new element, check how it affected the GWP system.
          BTW, we don't need this check when we delete an element from GWP
        */
        check_max_gwp_items(gwp_settings[tier_id]);

        //Check if we need to hide GWP block at all (because we might not have any content in that block);
        check_gwp_block_visibility();
      }

      //Select or Unselect product
      $block.classList.toggle('gwp-selected');
    })
  })



  //Check the gwp system each time the cart has some changes
  document.addEventListener('theme:cart:added', function(e){

    /*
      Check if something were changes in the cart data
      Otherwise we dont' need to run validation process.
      In some situation this event triggered without acutaly change
    */

    cart_new_data = JSON.stringify(cart);

    let cart_subtotal_without_gwp = Number(cart.cartForm.querySelector('[data-cart-total-without-gwp]').dataset.cartTotalWithoutGwp);

    if(cart_new_data == cart_previous_data){
      console.log("Cart - Something is updated, but all the same");
      return false;
    }
    cart_previous_data = cart_new_data; 

    /*
      Some changes were actually applied
      So we need to validate everything delete/add something and reapply discount code
    */

    console.log("Cart - Somthing is updated");

    cart_items_gwp = [];
    cart.items.forEach(item=>{
      cart_items_gwp.push({
        id: Number(item.dataset.item.split(':')[0]),
        quantity:Number(item.querySelector('input.cart__item__quantity-field').value),
        key:item.dataset.item,
        gwp_tier:item.dataset.gwpTier
      });
    });

    let closest_threshold = 0;


    $gwp_product.forEach(item=>{
      item.classList.remove('gwp-selected');
    })
    


    //Recalculate GWP Items In Cart
    for(let tier_id in gwp_settings){

      let tier = gwp_settings[tier_id];
      gwp_settings[tier_id].already_in_cart_count = 0;



      cart_items_gwp.forEach(item=>{
        if(tier.products.includes(item.id) && item.gwp_tier == tier_id){
          gwp_settings[tier_id].already_in_cart_count++;

          let $variant = $gwp_block.querySelector(`.tier-${tier_id}-content .variant-id-${item.id}`);
          $variant.classList.add('gwp-selected');
        }      
      });

      //Check what buttons should we add/hide + close the active popup if needed
      check_max_gwp_items(tier);
      
      /*
        Next Steps actuall only for GWP Original System
        Work with GWP button & GWP Threshold Bar
      */     
      if(tier.gwp_type != 'original'){
        continue;
      }

    
      //Change - get current tier and work with it later REBUILD
      //Check Tier Progress Bar if 
      if(cart_subtotal_without_gwp < tier.threshold && closest_threshold == 0 && !tier.hide_progress_bar){
        closest_threshold = tier.threshold;
        $tier_progress_bar_title.innerHTML = tier.title;
        $tier_progress_bar.querySelector('.end').innerHTML = rc_money_format(tier.threshold);
      }
    }


    /* Check what Original GWP Buttons we should hide/show
      It runs in separate loop because of Exclusive Tier (we need to calculate "already_in_cart_count" for all tiers before)
    */
    Object.values(gwp_settings).forEach(tier=>{
      if(tier.gwp_type == "original" && !gwp_tier_conditions_check(tier)){

        $gwp_open_button.forEach(item=>{
          if(item.classList.contains('gwp-open-button-tier-'+tier.id)){
            item.classList.remove('show-flex');
          }
        })
      }
    })


    if(apply_coupon){
      //Apply Coupon if this function exists
      apply_coupon();
    }

    //Run big test of GWP system condition (gwp items count/quantity, threshold)
    gwp_system_super_check();

    // Check if we reach a tier with one product and we need to auto-add this product 
    check_autoadd_gwp_tier();



    
    //Work With Tier Progress Bar
    if(closest_threshold){
      $tier_progress_bar.classList.add('show-flex');
      $tier_progress_bar_line.style.width = (cart_subtotal_without_gwp / closest_threshold)*100+'%';
      $tier_prgress_bar_value.innerHTML = rc_money_format(closest_threshold - cart_subtotal_without_gwp);
    }
    else{
      $tier_progress_bar.classList.remove('show-flex');
    }


    //Check if we need to hide GWP block at all
    check_gwp_block_visibility();

    gwp_exclusive_check("only_controls");

  });


  /*
    Function checks if we reach a tier with one product and we need to auto-add this product 
    + It should be original GWP tier, not coupon one
  */
  function check_autoadd_gwp_tier(){
    let add_data = [];

    //Recalculate GWP Items In Cart
    for(let tier_id in gwp_settings){
      let tier = gwp_settings[tier_id];


      if(tier.gwp_type == 'original' && tier.products.length == tier.max_gwp_items && gwp_tier_conditions_check(tier)){

        
        gwp_settings[tier_id].already_in_cart_count = 0;
        
        tier.products.forEach(one_product=>{
          /*
            For auto-add something, check
            1. The product wasn't already addded
            2. The product wasn't manually removed before
          */
          if(cart_items_gwp.every(item=>{
            return item.id != one_product || item.gwp_tier != tier_id
          }) && !gwp_previously_removed_check([one_product])){
            
            gwp_settings[tier_id].already_in_cart_count++;//this sum works only for items that we are adding right now

            add_data.push({
              id:one_product,
              quanity:1,
              properties:{
                _gwp_tier_id:tier_id,
                _gwp_reporting_title:gwp_settings[tier_id].reporting_title
              }
            })

          }


          // Check how many items we already has in the cart
          gwp_settings[tier_id].already_in_cart_count += cart_items_gwp.reduce((result, item)=>{
            return (item.id == one_product && item.gwp_tier == tier_id) ? result + 1 : result;
          },0)


        })
      }

    }

    //Add auto-added GWP
    if(add_data.length){
      gwp_ajax_work('add',{items:add_data});
    }    
  }


  /* Popup Work */
  $gwp_open_button.forEach(item=>{
    //Get needed tier for popup
    item.querySelector('.gwp-button').addEventListener('click', function(){
      let tier = this.dataset.tier;

      if(!tier){
        //We can't show popup if we don't have tier
        return false;
      }

      //Show Popup with Selected Tier
      show_gwp_popup(gwp_settings[tier], $gwp_block);
    })
  })




  /*
    Show Popup with GWP item
    we have $gwp_popup because it also works with GWP Coupon system
  */
  function show_gwp_popup(gwp_object, $gwp_popup){

    $gwp_popup.querySelector('h2').innerHTML = gwp_object.title; //Change popup header


    if(gwp_object.max_gwp_items - gwp_object.already_in_cart_count > 1){
      $gwp_popup.querySelector('.information').classList.remove('single')
      $gwp_popup.querySelector('.information').classList.add('multiple');

      $gwp_popup.querySelector('.available-gwp-count').innerHTML = gwp_object.max_gwp_items - gwp_object.already_in_cart_count;
    }
    else{
      $gwp_popup.querySelector('.information').classList.remove('multiple')
      $gwp_popup.querySelector('.information').classList.add('single');
    }

    let tier_products_count = gwp_object.products.length;


    $gwp_popup.classList.remove("gwp-count-1", "gwp-count-2", "gwp-count-3");
    $gwp_popup.classList.add("active", "gwp-count-"+tier_products_count);
    
    $gwp_popup.querySelectorAll('.tier-content').forEach(item=>{
      item.classList.remove("show");
    });


    $gwp_popup.querySelector('.tier-'+gwp_object.id+'-content').classList.add('show');
    

    $gwp_popup.dataset.tier_id = gwp_object.id;


    let $slider = $gwp_popup.querySelector('.tier-'+gwp_object.id+'-content .products-list')

    //Create Slider only if we have "desktop" resolution
    if(window.matchMedia('(min-width: 768px)').matches && (document.querySelector('.livingproof-style.hide-header') || (!document.querySelector('.livingproof-style.hide-header') && tier_products_count > 3))){
      let rc_slider_link = new themeVendor.Flickity( $slider, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: true,
        dragThreshold:3
      });
      rc_slider_link.resize();
    }
  }


  //Popup controls
  $gwp_block.addEventListener('click', (e)=>{
    if(!e.target.closest('.content')){
      $gwp_block.classList.remove('active');
    }
  })
  $gwp_block.querySelector('.icon-close').addEventListener('click',function(){
    this.closest('.gwp-popup').classList.remove('active');
  })







  //Close popup by "esc" button
  document.addEventListener("keydown", function(event) {
    if (event.key === "Escape" || event.keyCode === 27){
      document.querySelector('.gwp-popup.active')?.classList.remove('active');
    }
  });

  /* END Popup Work */



  function check_gwp_block_visibility(){
    if($gwp_block_wrapper.querySelectorAll('.show-flex').length){
      if($gwp_block_wrapper.classList.contains('make-hidden')){
        $gwp_block_wrapper.classList.remove('make-hidden');
        document.dispatchEvent(new Event('cart-drawer-size-change'));
      }
    }
    else{
      if(!$gwp_block_wrapper.classList.contains('make-hidden')){
         $gwp_block_wrapper.classList.add('make-hidden');
        document.dispatchEvent(new Event('cart-drawer-size-change'));
      }      
    }     
  }





  /* GWP Coupon */
  $gwp_coupon_block = document.querySelector('.gwp-coupon-block');




  /* Run this code only if we have Coupon Block on the page */
  if($gwp_coupon_block){


    let $coupon_field = $gwp_coupon_block.querySelector('.gwp_coupon_field');


    /* 
      apply_coupon - responsible for applying coupon when a user initially inserts it
      + each time something changed in the cart (because we need to check thresholds)
      + after page initially loaded 
    */
    apply_coupon = function(user_action){

      let code = $coupon_field.value.trim().toLowerCase();
      if(!code){
        return false;
      }
      console.log('Apply Coupon');


      /* Validation Process */

      let active_gwp_coupon = false;
      let lowest_threshold = 1000000000;
      let gwp_code_exists = false;

      let info_message = 'invalid';
      let info_message_data;

      let active_code_related_to_gwp_with_item_criteria = false;

      /* Check if the applied code exists in GWP Coupon System */
      for(let gwp_coupon_index in gwp_settings){
        let gwp_coupon = gwp_settings[gwp_coupon_index];

        if(gwp_coupon.code == code){
          gwp_code_exists = true; //Code Exists in GWP Coupon System


          /*
            Check if exits code related to GWP Tier with Item criteria
            We need it to:
            1. Exclude this Tier from lowest threshold calculation
            2. Show specific message for this type of tier
          */
          active_code_related_to_gwp_with_item_criteria = gwp_coupon.items_condition_amount > 0;


          /* Check if the Code meets threshold criteria */
          if(gwp_tier_conditions_check(gwp_coupon)){
            //Code meets threshold criteria
            active_gwp_coupon = gwp_coupon;
            /* 
              There may be 2 situation - 
              1. We have 1 GWP items and will be auto-added, so the validation status shoud be - "Complete"
              2. We have more than 1 GWP items, and they won't be auto-added, so the validation status should be - "Select"
            */
            info_message = (active_gwp_coupon.products.length === active_gwp_coupon.max_gwp_items && !gwp_previously_removed_check(active_gwp_coupon.products)) || active_gwp_coupon.already_in_cart_count >= active_gwp_coupon.max_gwp_items ? 'complete' : 'select'
          }
          else{
            /* 
              Code doesn't meet threshold criteria.
              We should save the problem threshold to show it in the validation message
            */
            lowest_threshold = lowest_threshold > gwp_coupon.threshold ? gwp_coupon.threshold : lowest_threshold;


            //don't count lowest_threhsold for gwp with item criteria

          }
        }
      }


      if(gwp_code_exists && !active_gwp_coupon){
        /* GWP Code exists but has some problem with validation conditions (threshold or items condition) */

        
        /* Check for active exclusive tier */
        let gwp_active_exclusive_tier = gwp_exclusive_check("only_tier");
        if(gwp_active_exclusive_tier){
          info_message = "exclusive-tier-problem";
        }
        else if(active_code_related_to_gwp_with_item_criteria){
          //Code related to GWP with items condition - we have simple message in this case
          info_message = 'items-condition-problem';
        }
        else{
          //Code related to GWP with items condition and cart total lower then GWP Tier Threshold condition
          info_message = "threshold";
          info_message_data = lowest_threshold;
        }        
      }


      let updates = [];
      /*
        Internal Validation is over. Now we can work with Actually Applied Coupon
      */
      if(active_gwp_coupon){

        /* This coupon works at least on GWP Level, so we need to save it for further use */
        gwp_used_coupon = code;
        setCookie("gwp_discount", gwp_used_coupon);
        $coupon_field.disabled = true;
        $gwp_coupon_block.classList.add('coupon-activated');
        


        if(active_gwp_coupon.products.length > active_gwp_coupon.max_gwp_items || gwp_previously_removed_check(active_gwp_coupon.products)){
          //Show Popup, if we have more than 1 product
          if(user_action){
            show_gwp_popup(active_gwp_coupon, $gwp_block);
          }              
        }
        else{
          /*
            Auto add if the Amount of Products on the GWP Tier == Max Amount of Products a user can add on the GWP Tier
            + Non of these product were manually deleted previously
          */
          /*
            Check if some products already exists in the cart
            This may happens due to asyc requests.
            I don't know if it may actually happens after I added "Request Collector", but this sever lines of code don't bother us
          */

          active_gwp_coupon.products.forEach(gwp_item=>{
            if(!cart_items_gwp.some(item => item.id == gwp_item && item.gwp_tier == active_gwp_coupon.id) && !gwp_previously_removed_check([gwp_item])){
              //Not Added -> Add
              updates.push({
                id:gwp_item,
                quanity:1,
                properties:{
                  _gwp_tier_id:active_gwp_coupon.id,
                  _gwp_reporting_title:active_gwp_coupon.reporting_title
                }
              })

            }
          })
        }
      }



      apply_discount_to_shopify(updates);

      //Actuall Apply the discount
      function apply_discount_to_shopify(updates){

        gwp_coupon_validation_status("applying");


        let shopify_discount_last_try = getCookie("shopify_discount_last_try")
        
        if(shopify_discount_last_try == code){
          console.log('Code Was Sent Earlier');

          if (Object.keys(updates).length > 0) {
            gwp_ajax_work('add', {items:updates}, apply_shopify_discount_after);          
          }
          else{
            apply_shopify_discount_after();
            
          }
        }
        else{
          console.log("Code Is Sent")

          gwp_ajax_work('update',{
            discount: code,
            attributes:{
              gwp_discount_code:code
            }
          },
          function(){
            setCookie("shopify_discount_last_try", code);
            apply_shopify_discount_after();
          });
          

          gwp_ajax_work('add',{
            items:updates
          })
          
        }



        function apply_shopify_discount_after(){
          let shopify_discount_active = false;
          let shopify_discount_info_message = 'invalid';
          /*
            Check if the code was applied
            We store date in Section, that we recive from cart API call
            + In the Discount Block (because this block loaded from the begining)
          */
          document.querySelectorAll('.applied_discount_codes').forEach(item=>{
            if(item.textContent.split(',').includes(code)){
              shopify_discount_active = true;
              shopify_discount_info_message = 'shopify-discount';
            }
          })

          if(shopify_discount_active){
            gwp_used_coupon = code;
            setCookie("gwp_discount", gwp_used_coupon);
            $coupon_field.disabled = true;
            $gwp_coupon_block.classList.add('coupon-activated');
          }


          gwp_coupon_validation_status({
            'shopify_discount':shopify_discount_info_message,
            'gwp':info_message
          }, info_message_data)       
        }

      }

    }


    //Check If the coupon was already used
    if(gwp_used_coupon){
      
      $coupon_field.value = gwp_used_coupon;
      $coupon_field.disabled = true;
      $gwp_coupon_block.classList.add('coupon-activated');

      //Check if a user selects all products
      apply_coupon();
    }


    //Accordion work
    $gwp_coupon_block.querySelector('.head').addEventListener('click', (e)=>{
      $gwp_coupon_block.classList.toggle('open');
    });


    //event triger when the coupon block is opened
    $gwp_coupon_block.addEventListener('transitionend',(e)=>{
      if(e.propertyName == 'max-height' && $gwp_coupon_block.classList.contains('open')){
        document.dispatchEvent(new Event('gwp-coupon-block-open'))
      }
    })




    //Delete Code
    $gwp_coupon_block.querySelector('.clear').addEventListener('click', (e)=>{
      $coupon_field.disabled = false;
      $coupon_field.value = '';
      $gwp_coupon_block.classList.remove('coupon-activated');
      setCookie("gwp_discount", '');
      setCookie("shopify_discount_last_try", '')



      //Check if we need to delete any product related to this Coupon Code
      let product_deletions = false;
      for(gwp_tier in gwp_settings){
        //Find related Tier
        if(gwp_settings[gwp_tier].gwp_type == 'coupon' && gwp_settings[gwp_tier].code == gwp_used_coupon){
          //Get All Products From related tier that in the cart right now
          product_deletions = delete_tier_products(cart_items_gwp, gwp_settings[gwp_tier], true);
        }
      }

      gwp_used_coupon = false;

      gwp_ajax_work("update",{
        discount: '',
        updates:product_deletions,
        attributes:{
          gwp_discount_code:''
        }
      })


      //Clear validation status
      document.querySelector('.gwp-coupon-block .validation').classList.remove('active');
    })


    //Show popup to applied coupon
    $gwp_coupon_block.querySelector('.show-gwp-coupon-popup').addEventListener('click', (e)=>{
      $gwp_coupon_block.querySelector('.apply-button').click();
    })


    //Apply Coupon by clicking on "Apply" button in the "Free Gift" block 
    $gwp_coupon_block.querySelector('.apply-button').addEventListener('click', function(){
      apply_coupon(true)
    });

    $coupon_field.addEventListener("keydown", (e)=>{
      if(e.keyCode == '13'){
        apply_coupon(true);
        e.preventDefault();
        return false;
      }
    })



  }

});






//Show needed validation status in the GWP Coupon section
function gwp_coupon_validation_status(status, data){


  let $validation_status = document.querySelector('.gwp-coupon-block .validation');

  //For some reason we don't have coupon validation element - so we shouldn't do anything
  if(!$validation_status){
    return false;
  }

  $validation_status.classList.add('active');


  //Hide "General" validation message
  $validation_status.querySelectorAll('.invalid,.applying').forEach(item=>{

    item.classList.remove('active');
  })




  if(status.gwp == 'invalid' && status.shopify_discount == 'invalid'){
    status = 'invalid';
  }

  //Check if we need to show "General" validation message
  if(status == 'applying' || status == 'invalid'){
    $validation_status.querySelectorAll('.active').forEach(item=>{
      item.classList.remove('active');
    });
     $validation_status.querySelector('.'+status).classList.add('active');
     return true;
  }


  if(status.gwp){
    $validation_status.querySelector('.gwp-related.active')?.classList.remove('active');
    $validation_status.querySelector('.gwp-related.'+status.gwp)?.classList.add('active');
    if(status.gwp == 'threshold'){
      $gwp_coupon_block.querySelector('.threshold .value').innerHTML = rc_money_format(data);
    }
  }


  if(status.shopify_discount){
    $validation_status.querySelector('.shopify-discount-related.active')?.classList.remove('active');
    $validation_status.querySelector('.shopify-discount-related.'+status.shopify_discount)?.classList.add('active');
  }

}






function rc_money_format(value){
  return rc_currency_symbol  + (value/100).toFixed(2);
}


/* GWP Coupon END*/


//Run Global GWP checks each time the cart synced (sync code in the assets/theme.js)


//Global check of all condition for GWP tiers (items count/quantity + threshold)
function gwp_system_super_check(){

  cart_items = cart_items_gwp.map(item => item.id);

  for(offer_id in gwp_settings){

    let offer = gwp_settings[offer_id]; 

    //check thresold
    
    if(!gwp_tier_conditions_check(offer)){
      //Delete all Tier Products
      delete_tier_products(cart_items_gwp, offer);
      continue;
    }


    //Check Max Amount & quantity
    let result_amount = 0;
    let quantity_problem = false;
    cart_items.forEach((item)=>{
      if(offer.products.includes(item.id) && item.gwp_tier == offer.id){
        //it's gwp product
        result_amount++;
        if(item.quantity > 1){
          //Delete all Tier products
          quantity_problem = true;
        }
      }
    });


    if(quantity_problem){
      delete_tier_products(cart_items_gwp, offer)
      continue;
    }

    if(offer.max_gwp_items < result_amount){
      //Delete all Tier products
      delete_tier_products(cart_items_gwp, offer)
      continue;
    }

    //Check Coupon
    if(offer.gwp_type == 'coupon' && offer.code != gwp_used_coupon){
      //Delete all Tier products
      delete_tier_products(cart_items_gwp, offer);
      continue;
    }

  }
}





//Remove all products from the chosen tier
function delete_tier_products(cart_products, tier, dont_actually_delete_just_return = false){

  let updates = {};
  let delete_something = false;
  

  cart_products.forEach((cart_product)=>{
    if(cart_product.gwp_tier == tier.id){
      updates[cart_product.key] = 0;
      delete_something = true;

      //Unselect this product in popup
      $gwp_block.querySelector(`.tier-${tier.id}-content .variant-id-${cart_product.id}`)?.classList.remove('gwp-selected');
    }
  });


  gwp_settings[tier.id].already_in_cart_count = 0;
  if(delete_something){

    if(dont_actually_delete_just_return){
      return updates
    }
    else{
      gwp_ajax_work('update', {updates:updates});
      return true;
    }
  }     
}








let gwp_cart_requests_process = false;
let gwp_ajax_queue = [];

//Function adds product to the cart via AJAX
function gwp_ajax_work(action, data, callback){





  if(gwp_cart_requests_process){
    gwp_ajax_queue.push([action, data, callback]);
    return true;
  }

  gwp_cart_requests_process = true;


  data.sections = "api-cart-items"

  fetch("/cart/"+action+".js",{
    "method":"POST",
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(response => response.json())
  .then(data => {  

    const element = document.createElement('div');
    element.innerHTML = data.sections['api-cart-items'];
    const cleanResponse = element.querySelector('[data-api-content]');
    cart.build(cleanResponse);      

    //Run Callback function, if it exists
    if(callback){
      callback(data);
    }


    
    gwp_cart_requests_process = false;
    if(gwp_ajax_queue.length){
      let [nextAction, nextData, nextCallback] = gwp_ajax_queue.shift();
      gwp_ajax_work(nextAction, nextData, nextCallback);
    }

  }).catch((error) => {
    gwp_cart_requests_process = false;
    if(gwp_ajax_queue.length){
      let [nextAction, nextData, nextCallback] = gwp_ajax_queue.shift();
      gwp_ajax_work(nextAction, nextData, nextCallback);
    }
  })

  //Check if we added GWP Exclusive Tier
  gwp_exclusive_check();

}




/*
  getCookie & setCookie defined in the "custom.js" file
*/


/* GWP Tier Conditions Check
  2 Criteria:
  1. Threshold
  2. Specific Item Condition
*/
function gwp_tier_conditions_check(tier){

  //Check if there any active GWP Exclusive Tier (and it isn't the current Tier)
  let exclusive_active_tier = gwp_exclusive_check("only_tier");


  if(exclusive_active_tier && exclusive_active_tier != tier.id){
    return false;
  }


  let cart_subtotal_without_gwp = Number(cart.cartForm.querySelector('[data-cart-total-without-gwp]').dataset.cartTotalWithoutGwp);


  let cart_total;
  if(tier.gwp_type == 'original' || tier.cart_total_used_for_spend_threshold == "Cart Total after Discounts"){
    cart_total = cart_subtotal_without_gwp;
  }
  else{
    cart_total = Number(cart.cartForm.querySelector('[data-cart-total-prediscount]').dataset.cartTotalPrediscount);
  }
  // let cart_total = tier.gwp_type == 'original' ? cart_subtotal_without_gwp : Number(cart.cartForm.querySelector('[data-cart-total-prediscount]').dataset.cartTotalPrediscount)


  let threshold_condition = cart_total >= tier.threshold && (!tier.threshold_max || cart_total < tier.threshold_max);

  let items_condition = tier.items_condition.reduce((accumulator, item)=>{
    return accumulator+= cart_items_gwp.some(cart_item=>{
      return cart_item.id == item;
    });
  }, 0);
  items_condition = items_condition >= tier.items_condition_amount;

  return threshold_condition && items_condition
}



/* Catch Deleted GWP */
document.addEventListener('click', (e)=>{
   let element = e.target;
   if(element.hasAttribute('data-item-remove') || element.parentElement.hasAttribute('data-item-remove')){
    let gwp = element.closest('.gwp-cart-item');
    if(gwp){
      let removed_id = gwp.dataset.item.split(':')[0]
      let removed_array = JSON.parse(localStorage.getItem('gwp-removed-items')) || [];
      if(!removed_array.includes(removed_id)){
        removed_array.push(removed_id);
        localStorage.setItem('gwp-removed-items', JSON.stringify(removed_array));
      }
    }
   }
})


/*
  Check if products was manually removed
  Return TRUE if one of ids (array) were removed
*/
function gwp_previously_removed_check(ids){
  let removed_array = JSON.parse(localStorage.getItem('gwp-removed-items')) || [];
  return ids.some(item=>{
    return removed_array.includes(String(item));
  }) 
}

function gwp_previously_removed_remove(id){
  let removed_array = JSON.parse(localStorage.getItem('gwp-removed-items')) || [];
  removed_array = removed_array.filter(item=>{
    return item != id; 
  });
  localStorage.setItem('gwp-removed-items', JSON.stringify(removed_array));
}




function gwp_exclusive_check(action = false){

  /* GWP Exclusive Tier Deletion Check Start */
  let exclusive_active_tier = Object.values(gwp_settings).find(item=>{
    return item.exclusive_gwp_tier && item.already_in_cart_count
  })?.id;


  if(action == 'only_tier'){
    return exclusive_active_tier;
  }


  if(exclusive_active_tier){
    document.querySelector('.gwp-wrapper').classList.add('gwp-exclusive-tire-active');
    if(action == 'only_controls'){
      return true;
    }

    //If there is any active GWP Exclusive Tier - Delete All Other Tiers in one call
    let product_deletions = {};
    Object.values(gwp_settings).forEach(item=>{
      if(item.id != exclusive_active_tier && item.already_in_cart_count){
        let tier_product_deletion = delete_tier_products(cart_items_gwp, item, true);
        Object.assign(product_deletions, tier_product_deletion);
      }
    })

    if(Object.keys(product_deletions).length > 0){
      gwp_ajax_work('update', {updates: product_deletions});
    }
  }
  else{
    document.querySelector('.gwp-wrapper').classList.remove('gwp-exclusive-tire-active');
  }
  /* GWP Exclusive Tier Deletion Check END */
}